import Vue from 'vue'
import VueI18n from 'vue-i18n'

const enData = require('@/assets/languages/AhaSlides_English.json')
const viData = require('@/assets/languages/AhaSlides_Vietnamese.json')
const esData = require('@/assets/languages/AhaSlides_Spanish.json')
const seData = require('@/assets/languages/AhaSlides_Swedish.json')
const brData = require('@/assets/languages/AhaSlides_Portuguese_BR.json')
const frData = require('@/assets/languages/AhaSlides_French.json')
const deData = require('@/assets/languages/AhaSlides_German.json')
const idData = require('@/assets/languages/AhaSlides_id.json')
const itData = require('@/assets/languages/AhaSlides_Italian.json')
const trData = require('@/assets/languages/AhaSlides_Turkish.json')
const csData = require('@/assets/languages/AhaSlides_Czech.json')
const krData = require('@/assets/languages/AhaSlides_Korean.json')
const noData = require('@/assets/languages/AhaSlides_Norwegian.json')
const jaData = require('@/assets/languages/AhaSlides_Japanese.json')
const nlData = require('@/assets/languages/AhaSlides_Dutch.json')
const ruData = require('@/assets/languages/AhaSlides_Russian.json')
const plData = require('@/assets/languages/AhaSlides_Polish.json')
const daData = require('@/assets/languages/AhaSlides_Danish.json')
const zhData = require('@/assets/languages/AhaSlides_Simplified_Chinese.json')
const slData = require('@/assets/languages/AhaSlides_Slovenia.json')
const siData = require('@/assets/languages/AhaSlides_Slovenia.json')
const lvData = require('@/assets/languages/AhaSlides_lv.json')
const elData = require('@/assets/languages/AhaSlides_Greek.json')
const ltData = require('@/assets/languages/AhaSlides_Lithuanian.json')
const hrData = require('@/assets/languages/AhaSlides_Croatian.json')
const isData = require('@/assets/languages/AhaSlides_Icelandic.json')
const bgData = require('@/assets/languages/AhaSlides_Bulgarian.json')
const roData = require('@/assets/languages/AhaSlides_Romanian.json')
const skData = require('@/assets/languages/AhaSlides_Slovakia.json')
const huData = require('@/assets/languages/AhaSlides_Hungary.json')
const sqData = require('@/assets/languages/AhaSlides_Albanian.json')

Vue.use(VueI18n)
const locale = 'en'
const messages = {
  en: enData,
  vi: viData,
  es: esData,
  br: brData,
  fr: frData,
  de: deData,
  id: idData,
  it: itData,
  tr: trData,
  ja: jaData,
  nl: nlData,
  ru: ruData,
  pl: plData,
  da: daData,
  zh: zhData,
  sl: slData,
  si: siData,
  lv: lvData,
  se: seData,
  el: elData,
  lt: ltData,
  hr: hrData,
  is: isData,
  bg: bgData,
  ro: roData,
  sk: skData,
  hu: huData,
  sq: sqData,
  cs: csData,
  no: noData,
  kr: krData,
}
const i18n = new VueI18n({
  locale,
  messages,
})
export default i18n
